import { useState } from 'react';
import axios from '../api/axios';
import { TextField, Button, Container, Typography, CircularProgress, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { red } from '@mui/material/colors';
import { usePending } from '../context/PendingContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { refreshPending } = usePending();

  const handleLogin = async () => {
    setLoading(true);
    setErrorMessage('');
    try {
      const res = await axios.post('/auth/login', { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user_id', res.data.user_id);
      localStorage.setItem('role', res.data.role);
      await refreshPending();
      // localStorage.setItem('pending_to_do', res.data.pending_to_do);
      //   navigate('/dashboard');
      navigate('/sites');
    } catch (err) {
      setErrorMessage('用戶名稱或密碼錯誤')
      // alert('Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >
      <Container maxWidth="xs" sx={{mt:8}} style={{display: "flex", flexDirection: "column"}}>
        <img style={{width: "200px", margin: "auto"}} src="/logo-color.svg" />
        {/* <Typography variant="h5">登入</Typography> */}
        <TextField sx={{mt:4}} fullWidth label="用戶名稱" margin="normal" value={username} onChange={(e) => setUsername(e.target.value)} />
        <TextField fullWidth label="密碼" type="password" margin="normal" value={password} onChange={(e) => setPassword(e.target.value)} />
        {/* Login fail error message */}
        {errorMessage ? (
          <span style={{ color: red[800] }}>{errorMessage}</span>
        ) :
          ""
        }
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={handleLogin}>登入</Button>
        )}
      </Container>
    </div>
  );
}
